import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import yellow_exclamation_mark from '../../../icons/yellow_exclamation_mark.svg';


 function Message(props) {


  return (
    <div className='container-message'>
      <div className='wrapper-message'>
        <Image src={yellow_exclamation_mark} alt='icon' />
      </div>
      <div>
      בתאריך 1.1.2025 עודכן שיעור המע"מ ל-18%. חשבון זה כולל חיוב עבור הפרשי מע"מ מחשבון דצמבר
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Message);
